import React from 'react';
import NavItem from '../atoms/NavItem';
import './Navigation.css';

interface NavItemData {
  id: string;
  label: string;
  icon: 'dashboard' | 'cart' | 'cake' | 'calendar' | 'users' | 'chart' | 'gear' | 'storefront';
}

interface NavigationProps {
  items: NavItemData[];
  activeTab: string;
  isCollapsed: boolean;
  onTabChange: (tabId: string) => void;
}

const Navigation: React.FC<NavigationProps> = ({ 
  items, 
  activeTab, 
  isCollapsed, 
  onTabChange 
}) => {
  return (
    <nav className="sidebar-nav">
      {items.map((item) => (
        <NavItem
          key={item.id}
          id={item.id}
          label={item.label}
          icon={item.icon}
          isActive={activeTab === item.id}
          isCollapsed={isCollapsed}
          onClick={() => onTabChange(item.id)}
        />
      ))}
    </nav>
  );
};

export default Navigation;
